import { render } from "./JobCard.vue?vue&type=template&id=fc6774ea"
import script from "./JobCard.vue?vue&type=script&lang=js"
export * from "./JobCard.vue?vue&type=script&lang=js"

import "./JobCard.vue?vue&type=style&index=0&id=fc6774ea&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__